var _rect, _path, _circle, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaxSavingDeposit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 15.5,
    width: 15,
    height: 19,
    rx: 1.5,
    fill: "white",
    stroke: "#183883"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2642 24.2031V23.6364H22.6413V24.2031H21.2798V28H20.6236V24.2031H19.2642ZM23.8436 28.0724C23.6362 28.0724 23.4487 28.0341 23.2811 27.9574C23.1135 27.8793 22.9806 27.7663 22.8826 27.6186C22.786 27.4709 22.7377 27.2898 22.7377 27.0753C22.7377 26.8906 22.7733 26.7386 22.8443 26.6193C22.9153 26.5 23.0112 26.4055 23.1319 26.3359C23.2527 26.2663 23.3876 26.2138 23.5368 26.1783C23.6859 26.1428 23.8379 26.1158 23.9927 26.0973C24.1887 26.0746 24.3478 26.0561 24.47 26.0419C24.5922 26.0263 24.6809 26.0014 24.7363 25.9673C24.7917 25.9332 24.8194 25.8778 24.8194 25.8011V25.7862C24.8194 25.6001 24.7669 25.456 24.6618 25.3537C24.5581 25.2514 24.4032 25.2003 24.1973 25.2003C23.9828 25.2003 23.8137 25.2479 23.6902 25.343C23.568 25.4368 23.4835 25.5412 23.4366 25.6562L22.8379 25.5199C22.9089 25.321 23.0126 25.1605 23.149 25.0384C23.2868 24.9148 23.4451 24.8253 23.6241 24.7699C23.8031 24.7131 23.9913 24.6847 24.1887 24.6847C24.3194 24.6847 24.4579 24.7003 24.6042 24.7315C24.752 24.7614 24.8897 24.8168 25.0176 24.8977C25.1468 24.9787 25.2527 25.0945 25.335 25.245C25.4174 25.3942 25.4586 25.5881 25.4586 25.8267V28H24.8365V27.5526H24.8109C24.7697 27.6349 24.7079 27.7159 24.6255 27.7955C24.5431 27.875 24.4373 27.9411 24.3081 27.9936C24.1788 28.0462 24.024 28.0724 23.8436 28.0724ZM23.9821 27.5611C24.1582 27.5611 24.3088 27.5263 24.4338 27.4567C24.5602 27.3871 24.6561 27.2962 24.7214 27.1839C24.7882 27.0703 24.8216 26.9489 24.8216 26.8196V26.3977C24.7988 26.4205 24.7548 26.4418 24.6895 26.4616C24.6255 26.4801 24.5524 26.4964 24.47 26.5107C24.3876 26.5234 24.3074 26.5355 24.2292 26.5469C24.1511 26.5568 24.0858 26.5653 24.0332 26.5724C23.9096 26.5881 23.7967 26.6143 23.6944 26.6513C23.5936 26.6882 23.5126 26.7415 23.4515 26.8111C23.3919 26.8793 23.362 26.9702 23.362 27.0838C23.362 27.2415 23.4203 27.3608 23.5368 27.4418C23.6532 27.5213 23.8017 27.5611 23.9821 27.5611ZM26.81 24.7273L27.5323 26.0014L28.261 24.7273H28.9577L27.9371 26.3636L28.9663 28H28.2695L27.5323 26.777L26.7972 28H26.0984L27.1168 26.3636L26.1112 24.7273H26.81Z",
    fill: "#183883"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 24.5,
    stroke: "#183883"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 18H30",
    stroke: "#183883",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 21H28",
    stroke: "#183883",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20 31H25",
    stroke: "#183883",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxSavingDeposit);
export default __webpack_public_path__ + "static/media/TaxSavingDeposit.932a547fcb7b71517ea2587cfc7d95cc.svg";
export { ForwardRef as ReactComponent };